import { render, staticRenderFns } from "./SettingsCallQueues.vue?vue&type=template&id=5dce4d9f&scoped=true"
import script from "./SettingsCallQueues.vue?vue&type=script&lang=js"
export * from "./SettingsCallQueues.vue?vue&type=script&lang=js"
import style0 from "./SettingsCallQueues.vue?vue&type=style&index=0&id=5dce4d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce4d9f",
  null
  
)

export default component.exports